"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFinishESignProcessService = void 0;
const hooks_1 = require("../../hooks");
const useFinishESignProcessService = (repository) => {
    const { call: finishESignProcessCall, isLoading: isFinishESignProcessLoading, isSuccess: isFinishESignProcessSuccess, isError: isFinishESignProcessError, } = (0, hooks_1.useAsyncStateInfo)(repository.finishESignProcess);
    return {
        finishESignProcessCall,
        isFinishESignProcessLoading,
        isFinishESignProcessSuccess,
        isFinishESignProcessError,
    };
};
exports.useFinishESignProcessService = useFinishESignProcessService;
//# sourceMappingURL=useFinishESignProcessService.hook.js.map